import { callAPI } from "./apiUtils";
import { apiUrls } from "./apiUrls";

// Demo mode (no backend needed): start the app with REACT_APP_PRINT_FAILURES_MOCK=true.
export const USING_MOCK_PRINT_FAILURES = process.env.REACT_APP_PRINT_FAILURES_MOCK === "true";

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * @param {"today"|"yesterday"|"7d"} range
 * @returns {Promise<{failures: Array, generatedAt: string}>}
 */
export const fetchPrintFailures = async (range) => {
  if (USING_MOCK_PRINT_FAILURES) {
    // Loaded on demand so the dummy data never ships in the normal bundle path.
    const { buildMockFailures, filterMockByRange } = await import("./mockPrintFailures");
    await wait(350);
    return {
      failures: filterMockByRange(buildMockFailures(), range),
      generatedAt: new Date().toISOString(),
    };
  }
  const res = await callAPI(apiUrls.PRINT_FAILURES, { range }, "GET");
  return {
    failures: res.data?.data?.failures || [],
    generatedAt: res.data?.data?.generated_at || new Date().toISOString(),
  };
};
